<template>
  <router-view />
</template>

<script> 

export default { 
  watch:{
    '$route'(to,form){
      document.title = document.title !== '仁创线上展' ? '仁创线上展' : document.title;
    }
  },
};
</script>

<style lang="scss">
</style>
